import { QueryClient, QueryCache } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { debouncedHandleError } from "./akios/error";
import useServerError from "./routes/errors/serverError/useServerError";

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => {
      debouncedHandleError(error as AxiosError, (error: Error) =>
        useServerError.setState({ error }),
      );
    },
  }),
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
    mutations: {},
  },
});
